export default "__VITE_ASSET__Bak784_$__"